export default __webpack_public_path__ + "static/media/n_wdt_c_4.ebb1984b.mp3";